/* ADSCALAR — confetti celebration for the unlocked cart offer.
   Vanilla canvas, no library (nothing to load, nothing to block).

   Quality notes, since a cheap burst looks worse than none at all:
     • ribbons, not dots — each piece is a rectangle whose horizontal scale is
       driven by its own spin, so it reads as paper catching the light
     • two offset bursts with different speeds, so the shape isn't a neat arc
     • per-piece drag, gravity, wobble and terminal velocity
     • devicePixelRatio-aware canvas, so it is not soft on retina screens
     • fades out rather than vanishing, and the canvas removes itself

   Honours prefers-reduced-motion by doing nothing at all.
   Exposes window.ekConfetti(anchorEl).  */
(function () {
  var COLORS = ['#990F4B', '#7A0C3B', '#2E1B54', '#E9D8A6', '#F5F0E8', '#C9A227'];

  function reduced() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  function burst(anchor) {
    if (reduced()) return;

    var rect = anchor && anchor.getBoundingClientRect
      ? anchor.getBoundingClientRect()
      : { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
    if (!rect.width && !rect.height) return;

    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2000';
    document.body.appendChild(cv);

    var ctx = cv.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() {
      cv.width = Math.floor(window.innerWidth * dpr);
      cv.height = Math.floor(window.innerHeight * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();

    var cy = rect.top + rect.height / 2;
    // Two origins just inside the banner's ends — a single centre point reads
    // as a fountain, two reads as a celebration.
    var origins = [
      { x: rect.left + rect.width * 0.22, dir: -1 },
      { x: rect.left + rect.width * 0.78, dir: 1 }
    ];

    var pieces = [];
    origins.forEach(function (o) {
      for (var i = 0; i < 46; i++) {
        var ang = -Math.PI / 2 + (Math.random() - 0.5) * 1.5 + o.dir * 0.35;
        var sp = 5.5 + Math.random() * 7.5;
        pieces.push({
          x: o.x + (Math.random() - 0.5) * 12,
          y: cy + (Math.random() - 0.5) * 8,
          vx: Math.cos(ang) * sp,
          vy: Math.sin(ang) * sp,
          w: 5 + Math.random() * 5,
          h: 8 + Math.random() * 7,
          spin: (Math.random() - 0.5) * 0.34,
          rot: Math.random() * Math.PI,
          tilt: Math.random() * Math.PI,
          tiltV: 0.06 + Math.random() * 0.08,
          drag: 0.986 + Math.random() * 0.008,
          color: COLORS[(Math.random() * COLORS.length) | 0],
          life: 0
        });
      }
    });

    var GRAV = 0.24;
    var MAXV = 9;
    var LIFE = 150; // frames ≈ 2.4s at 60fps
    var raf = null;
    var stopped = false;

    function cleanup() {
      stopped = true;
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('resize', size);
      if (cv.parentNode) cv.parentNode.removeChild(cv);
    }

    function frame() {
      if (stopped) return;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      var alive = 0;

      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        p.life++;
        if (p.life > LIFE) continue;

        p.vy = Math.min(p.vy + GRAV, MAXV);
        p.vx *= p.drag;
        p.vy *= 0.999;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.spin;
        p.tilt += p.tiltV;

        if (p.y - p.h > window.innerHeight) continue;
        alive++;

        // Fade over the last third of life.
        var t = p.life / LIFE;
        ctx.globalAlpha = t > 0.66 ? 1 - (t - 0.66) / 0.34 : 1;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        // Horizontal squash from the tilt = the paper turning edge-on.
        ctx.scale(Math.cos(p.tilt), 1);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }

      ctx.globalAlpha = 1;
      if (!alive) { cleanup(); return; }
      raf = requestAnimationFrame(frame);
    }

    window.addEventListener('resize', size);
    raf = requestAnimationFrame(frame);
    // Hard stop, so a backgrounded tab can never leave the canvas behind.
    setTimeout(cleanup, 6000);
  }

  window.ekConfetti = burst;
})();
